import React from "react";
import "../styles/scss/panels/_footer.scss";
import logo from "../styles/assets/img/JMSOFTCR_sin_fondo_letras_blancas.png";
import IconoFacebook from "../styles/assets/img/Facebook-icon.png";
import IconoInstagram from "../styles/assets/img/Instagram-icon.png";
import IconoYoutube from "../styles/assets/img/Youtube-icon.png";
import IconoLinkedin from "../styles/assets/img/Linkedin-icon.png";

export default function Footer() {
  return (
    <div className="footer align-items-stretch">
      <div className="footer-content">
      </div>
      <div className="footerAbajo">
        <div className="column">
          <a
            href="https://jmsoftcr.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="about-link"
          >
            About Us
          </a>
        </div>

        <div className="column">
          {/* <label>2025 Sistema Feria Barranca Puntarenas</label> */}
          <label><img src={logo} alt="Logo" style={{ height: "60px" }} /></label>
        </div>
        <div className="column">
          <img src={IconoFacebook} alt="Imagen 4" className="circle-image" />
          <img src={IconoInstagram} alt="Imagen 5" className="circle-image" />
          <img src={IconoYoutube} alt="Imagen 6" className="circle-image" />
          <img src={IconoLinkedin} alt="Imagen 7" className="circle-image" />
        </div>
      </div>
    </div>
  );
}